import React from "react";
import { Card, CardBody } from "reactstrap";
import handleValidDate from "../../../helpers/utils/handleValidDate";

function UpcommingEvents(props) {
  const category = props?.event?.className?.split("-")[2];
  return (
    <Card className="mb-3">
      <CardBody>
        <div className="d-flex mb-3">
          <div className="flex-grow-1">
            <i className={"mdi mdi-checkbox-blank-circle me-2 text-" + category} style={category ? {} : { color: props?.event?.color }} ></i>
            <span className="fs-12">
              {handleValidDate(props.event.start, "DD MMM YY") !== handleValidDate(props.event.end, "DD MMM YY") ?
                handleValidDate(props.event.start, "DD MMM YYYY") + " s.d " + handleValidDate(props.event.end, "DD MMM YYYY") : handleValidDate(props.event.end, "DD MMM YY")}
            </span>
          </div>
          <div className="flex-shrink-0">
            <small className="badge badge-soft-primary ms-auto">
              {handleValidDate(props.event.start, "HH:mm") !== handleValidDate(props.event.end, "HH:mm") ?
                handleValidDate(props.event.start, "HH:mm") + " - " + handleValidDate(props.event.end, "HH:mm") : "Fullday"}

            </small>
          </div>
        </div>
        <h6 className="card-title fs-16">{props.event.title}</h6>
        <p className="text-muted text-truncate-two-lines mb-0">
          {props.event.description}
        </p>
      </CardBody>
    </Card>
  );
}

export default UpcommingEvents;